/* RESPONSIBLE TEAM: team-rd-services */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAiAgentAnalyzeMonitorEditNewScorecardAttributeValueRoute extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.edit.new-scorecard.attribute.value',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAiAgentAnalyzeMonitorEditNewScorecardAttributeValueRoute);
